import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-button-secondary",
  templateUrl: "./button-secondary.component.html",
  styleUrls: ["./button-secondary.component.scss"],
})
export class ButtonSecondaryComponent {
  @Input() buttonCaption: string = "Publish";
  @Input() buttonType: string = "submit";
  @Input() buttonClassName: string = "";
  @Input() buttonIcon: string = "";
  @Input() buttonIconWidth: string = "auto";
  @Input() buttonDisabled: boolean = false;
  @Output() actionButtonCall = new EventEmitter<any>();
  @Input() btnMinWidth: string = "initial";
  @Input() btnHeight: string = "40px";
  @Input() isBtnDisabled: boolean = false;
  @Input() loaderEnabledFlag: boolean = false;

  clickEvent(buttonData: any) {
    this.actionButtonCall.emit(buttonData);
  }
}
